class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.htmlItems = [];
    this.itemsJSON = [];
    this.displayAtProductIndex = 0
    this.selectedProductIndex = 0
    this.amountOfProductsDisplayed = 3
    this.refreshBtnText = 'See More'
    this.selectedProductTitle = ''
    this.selectedProductType = ''
    this.selectedProductPrice = ''
    this.parentProductTitle = this.dataset.parentProductTitle
    this.parentProductType = this.dataset.parentProductType
    this.parentProductPrice = this.dataset.parentProductPrice
    this.initialButtonText = ''
    // init method -- essentailly, populate the data fields and get intial render
    const handleIntersection = (entries, observer) => {
      // if no entries
      if (!entries[0]) {
        this.style.display = 'none'
        return
      }
      observer.unobserve(this);
      fetch(this.dataset.url).then(r => {
        return r.json()
      }).then(data => {
        // If product has an associated collection
        if(data.products.length) {
          this.itemsJSON = data
        } else {
          // Use product upsell JSON, if it is not null
          if($("#UpSellsJSON").length) {
            this.itemsJSON = $.parseJSON($("#UpSellsJSON").html())
          }
        }
        //Requirement: If no upsells hide the section
        if(this.itemsJSON.length <= 0) {
          this.style.display = 'none'
        }
        this.renderHTML()
      }).catch(e => {
        console.error(e);
      });
    }
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }

  /**
   * Builds an unrendered HTML element that represents a line detail of the recommended products
   * @param
   */
  buildRecommendedLineDetails() {
    function shuffleArray(array) {
      let curId = array.length
      // There remain elements to shuffle
      while (0 !== curId) {
        // Pick a remaining element
        let randId = Math.floor(Math.random() * curId)
        curId -= 1;
        // Swap it with the current element.
        let tmp = array[curId]
        array[curId] = array[randId]
        array[randId] = tmp
      }
      return array;
    }

    var html = document.createElement('div');
    // Variable to check if this is the first time this was run
    var isInitial = this.htmlItems.length == 0 ? true : false;

    // Requirement - if there are more than three products available and this method runs after initial run,
    // instead of taking first three products, take three random from the available.

    // Store in temp array for easier processing
    let tempDataArray = []
    for(const key in this.itemsJSON) {
      // store in temporary array for transformationscreate all html nodes and store
      this.itemsJSON[key].forEach(item => {
        tempDataArray.push(item)
      })
    }

    if(isInitial) {
      // leave in current order
    } else {
      // randomize if refreshed
      this.htmlItems = []
      if(tempDataArray.length > this.amountOfProductsDisplayed) tempDataArray = shuffleArray(tempDataArray)
    }

    // Set component meta
    let isFirstIteration = true
    //for(const key in this.itemsJSON) {
      //// create all html nodes and store
      //this.itemsJSON[key].forEach(itm => {
        //let htmlItem = this.recommendationItemHTML(itm)
        //this.htmlItems.push(htmlItem)
        //if(isFirstIteration) {
        //  this.selectedProductType = itm.product_type
        //  this.selectedProductTitle = itm.title
        //  this.selectedProductVariants = itm.variants
        //  isFirstIteration = false
        //}     
      //})
    //}

    tempDataArray.forEach(itm => {
      let htmlItem = this.recommendationItemHTML(itm)
        this.htmlItems.push(htmlItem)
        if(isFirstIteration) {
          this.selectedProductType = itm.product_type
          this.selectedProductTitle = itm.title
          this.selectedProductPrice = itm.variants.length ? itm.variants[0].price : null
          this.selectedProductVariants = itm.variants
          isFirstIteration = false
          this.initialButtonText = this.decideRefreshBtnText()
          //Initial attempt to set text, timimng dependent
          try {
            let addRecommendationsToCartBtn = document.querySelector('.lb-add-recommendation-to-cart')
            addRecommendationsToCartBtn.innerHTML = this.decideRefreshBtnText()        
          } catch(e) {
            console.log(e)
          }
          }
    })

    try {
      // prepare HTML block
      for (let i = 0; i < this.htmlItems.length; i++){
        html.innerHTML += this.htmlItems[i]
        // - Use first x products
        if( i >= this.amountOfProductsDisplayed - 1) {
          break
        }
      }
      return html
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * An HTML element that serves as a line detail of the recommended products.
   * @param {{Object<JSON>} item - JSON object dervived from product API call
   */
  recommendationItemHTML(item) {
    function getImage(image, size = 300) {
      if (!image) return "";
      const ext = image.match(/\.(?:jpg|gif|png)/g);
      return image.replace(ext[0], `_${size}x` + ext[0]);
    }

    function buildImage(item) {
      if (!item) return "";
      return `<img alt="" class="responsive-image__image lazyload" data-sizes="auto" src="${getImage(
        item.images[0].src,
        30
      )}" data-src="${getImage(item.images[0].src, 150)}">`;
    }

    // Assign the template to variable
    let recommendedItem = reccomendationItem;
    
    // Fill in template
    recommendedItem = recommendedItem.replace(/{{itemImage}}/g, buildImage(item));
    recommendedItem = recommendedItem.replace(/{{itemID}}/g, item.variants.length ? item.variants[0].id : id);
    recommendedItem = recommendedItem.replace(/{{itemTitle}}/g, item.title);
    recommendedItem = recommendedItem.replace(/{{itemType}}/g, item.product_type);
    recommendedItem = recommendedItem.replace(/{{itemPrice}}/g, item.variants.length ? item.variants[0].price : null);
    return recommendedItem;
  }

  /**
   * Renders the created line item details to the window
   * @param
   */
  renderHTML() {
    //concatentate rendered html to correct place
    var html = this.buildRecommendedLineDetails()
    var recommendationsArea = this.querySelector('.lb-recommended-products')
    
    //Requirement: ATC Button text to be determined by the product type of the initial product as well as the upsell.
    //EX: Initial product type  = bag, upsell product type = 'accessory', resulting text 'add bag + accessory - $price'.
    //html.innerHTML += `<div class="lb-add-recommendation-to-cart">Button</div>`
    
    //post processsing
    try{
      if(html.querySelector('div > .lb-recommendation-items__item:first-of-type')) {
        html.querySelector('div > .lb-recommendation-items__item:first-of-type').classList.add('selected-recommendation')
      }
      recommendationsArea.innerHTML = html.innerHTML;
    } catch(e) {
      console.log(e)
    }
  }

  switchSelectedRecommendation(e) {
    if (target.hasClass('lb-recommendation-items__item')) {
      console.log('recommendation clicked')
    }
  }

  decideRefreshBtnText() {
    //get type of first product
    let majorType = this.parentProductType ? this.parentProductType : this.parentProductTitle
    let minorType = this.selectedProductType ? this.selectedProductType : this.selectedProductTitle
    return `add ${majorType} (${this.parentProductPrice}) + ${minorType} ($${this.selectedProductPrice})`
    
  }
  
}

customElements.define('product-recommendations', ProductRecommendations);
var rci = document.querySelector('.product-recommendations')
rci.buildRecommendedLineDetails()

document.addEventListener("DOMContentLoaded", () => {
  console.log('loaded')
  let productRecommendationComponent = document.querySelector('product-recommendations')
  let addRecommendationsToCartBtn = document.querySelector('.lb-add-recommendation-to-cart')
  let refreshBtn = document.querySelector('.lb-refresh-recommendations')
  
  // Show Button -- prevents flash when text changes

  //this ensures there is text for the button on load, in case timing was off on the initial set -- CTRL F "Initial attempt to set text"
  addRecommendationsToCartBtn.style.display = 'flex'
  if(productRecommendationComponent.initialButtonText) {
    addRecommendationsToCartBtn.innerHTML = productRecommendationComponent.decideRefreshBtnText()
  }

  if (productRecommendationComponent.amountOfProductsDisplayed < productRecommendationComponent.htmlItems.length) {
    refreshBtn.style.display = 'flex'
  }
});
